import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '配信期間',

  // model
  deliveryTypeModel: [],
  deliveryPeriodModel: [],
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {deliveryTypeParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceDeliveryType'],
        ['v1ServiceDeliveryTypeDetailGet'],
        [deliveryTypeParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setDeliveryTypeModel', res[0].data.serviceDeliveryTypeInfo)
            commit('setDeliveryPeriodModel', res[0].data.ServiceDeliveryPeriods)
            console.log('deliveryTypeModel', state.deliveryTypeModel)
            console.log('deliveryPeriodModel', state.deliveryPeriodModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.serviceDeliveryPeriodUUid)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setDeliveryTypeModel (state, data) {
    Vue.set(state, 'deliveryTypeModel', data)
  },
  setDeliveryPeriodModel (state, data) {
    Vue.set(state, 'deliveryPeriodModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpDeliveryFrequency', '')
    Vue.set(state.values, 'inpDeliveryTarget', '')
    Vue.set(state.values, 'inpDeliveryTerm', null)
    Vue.set(state.values, 'inpDeliveryStartHour', '')
    Vue.set(state.values, 'inpDeliveryStartMinute', '')
    Vue.set(state.values, 'inpDeliveryEndHour', '')
    Vue.set(state.values, 'inpDeliveryEndMinute', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    //TODO 選択された配信期間のモデルから初期値を代入
    Vue.set(state.values, 'inpDeliveryFrequency', data.deliveryFrequencyKbn)
    Vue.set(state.values, 'inpDeliveryTarget', data.deliveryToKbn)
    Vue.set(state.values, 'inpDeliveryTerm', data.deliveryPeriodDays)

    if (data.deliveryStartTime) {
      Vue.set(state.values, 'inpDeliveryStartHour', data.deliveryStartTime.split(':')[0])
      Vue.set(state.values, 'inpDeliveryStartMinute', data.deliveryStartTime.split(':')[1])
    } else {
      Vue.set(state.values, 'inpDeliveryStartHour', '')
      Vue.set(state.values, 'inpDeliveryStartMinute', '')
    }

    if (data.deliveryEndTime) {
      Vue.set(state.values, 'inpDeliveryEndHour', data.deliveryEndTime.split(':')[0])
      Vue.set(state.values, 'inpDeliveryEndMinute', data.deliveryEndTime.split(':')[1])
    } else {
      Vue.set(state.values, 'inpDeliveryEndHour', '')
      Vue.set(state.values, 'inpDeliveryEndMinute', '')
    }
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
